import { faPencil, faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@partful/shared/ui/Button';
import { useTranslation } from 'react-i18next';
import styles from './StepNoticeControls.module.scss';

export interface StepNoticeControlsProps {
  index: number;
  onEditClick: () => void;
  onDeleteClick: () => void;
}

export function StepNoticeControls({ index, onEditClick, onDeleteClick }: Readonly<StepNoticeControlsProps>) {
  const { t: i18n } = useTranslation();
  return (
    <div className={styles.controls}>
      <Button
        name="instructions_stepeditor_delete_notice_click"
        icon
        variant="secondary"
        size="small"
        onClick={onDeleteClick}
        title={i18n('instructions:step.notice.delete')}
        data-testid={`delete-step-notice-${index}-btn`}
      >
        <FontAwesomeIcon icon={faTrash} />
      </Button>
      <Button
        name="instructions_stepeditor_edit_notice_click"
        icon
        variant="secondary"
        size="small"
        onClick={onEditClick}
        title={i18n('instructions:step.notice.edit')}
        data-testid={`edit-step-notice-${index}-btn`}
      >
        <FontAwesomeIcon icon={faPencil} />
      </Button>
    </div>
  );
}
